import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { MenuItem } from 'material-ui';
import { getsettingIcon } from '../contractingUtils';
import FlatDropDownMenu from '../../tc-ui/flatDropDownMenu';
import EditButton from '../generic-components/edit-button';

export const priorities = [
  'Highest',
  'High',
  'Medium',
  'Low',
  'Lowest',
];

class UpdateRateConversionSetting extends Component {
  constructor() {
    super();
  }
  updateRCSetting = newsetting => () => {
    const { contractId, updateRCSetting } = this.props;
    updateRCSetting({ contractId, updater: { rateConversionSetting: newsetting } });
  };
  render() {
    const {
      setting,
      button,
    } = this.props;
    return (
      <FlatDropDownMenu
        button={
          button || <EditButton/>
        }
      >
        {
          ['opt-in', 'opt-out'].map(str => (
            <MenuItem
              key={str}
              primaryText={str === 'opt-in' ? 'Yes' : 'No'}
              disabled={str === setting}
              onClick={this.updateRCSetting(str)}
            />
          ))
        }
      </FlatDropDownMenu>
    );
  }
}

UpdateRateConversionSetting.propTypes = {
  updateRCSetting: PropTypes.func,
  contractId: PropTypes.string,
  setting: PropTypes.string,
  button: PropTypes.node,
};

export default connect(null, ({
  updateRCSetting: payload => ({ type: '[contract-request] UPDATE_RATE_CONVERSION_SETTING', payload }),
}))(UpdateRateConversionSetting);



// WEBPACK FOOTER //
// ./src/app/components/contracting/dummy-account/update-rate-conversion-settings.jsx